var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricMotors01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.52,13.31H2.48V2.28h11.03V13.31z M2.98,12.81h10.03V2.78H2.98V12.81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.1,9.44V6.64h0.43v0.39C6.61,6.89,6.73,6.78,6.88,6.7c0.15-0.08,0.31-0.13,0.5-0.13c0.21,0,0.38,0.04,0.51,0.13 c0.13,0.09,0.23,0.21,0.28,0.36c0.22-0.33,0.51-0.49,0.87-0.49c0.28,0,0.49,0.08,0.64,0.23s0.22,0.39,0.22,0.71v1.93H9.43V7.67 c0-0.19-0.01-0.33-0.05-0.41C9.36,7.18,9.3,7.11,9.22,7.06C9.14,7.01,9.04,6.98,8.93,6.98c-0.2,0-0.36,0.07-0.49,0.2 c-0.13,0.13-0.2,0.34-0.2,0.63v1.63H7.77V7.62c0-0.21-0.04-0.37-0.12-0.48s-0.2-0.16-0.38-0.16c-0.13,0-0.26,0.04-0.37,0.11 C6.79,7.16,6.7,7.26,6.65,7.4C6.6,7.54,6.58,7.73,6.58,7.99v1.46H6.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricMotors01);
export default __webpack_public_path__ + "static/media/ElectricMotors-01.97ca95e02f18d7278811f868240fa432.svg";
export { ForwardRef as ReactComponent };